
<template>
  <div class="toolTip-box">
    <div class="conttent">
      <h2 class="title">设置更新</h2>
      <p>已为您预约更新，我们将在设备下次联网时为您同步最新的设置。</p>
      <p>如您希望立即更新，请长按设备右键（后翻页键）激活设备联网。</p>
      <p class="need">同步需要一些时间，请稍候！</p>
      <div class="pic" :style="{backgroundImage: 'url('+ imgUrl +')'}"></div>
      <div class="btn-box">
          <!-- <button class="f-l btn next" @click="nextUpdate">下次更新</button> -->
          <button class="btn now" @click="nowUpdate">知道了</button>
      </div>
    </div>
  </div>
</template>
<script>
import Common from '../../assets/js/common.js'
export default {
  name: 'TtipSelectBox',
  data () {
    return {
      checked: true,
      tipArr: [],
      imgUrl: Common.staticHref() + 'img/settingIcon.jpg'
    }
  },
  methods: {
    resolveTips () {
      if (this.tips) {
        if (this.tips.indexOf('$$') > -1) {
          this.tipArr = this.tips.split('$$')
        } else {
          this.tipArr.push(this.tips)
        }
      }
    },
    nextUpdate () {
      this.$emit('next')
    },
    nowUpdate () {
      this.$emit('now')
    }
  },
  mounted () {
    this.resolveTips()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.toolTip-box
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0,0,0,.5)
  text-align center
  rowCloCenter()
  z-index 999999
  .conttent
    background #ffffff
    width 344px
    padding 10px
    border-radius 10px
    colmCenter()
    .title
      font-size 16px
      line-height 35px
      color #333333
    .pic
      width 155px
      height 135px
      background-position center center
      background-repeat no-repeat
      background-size contain
      margin 0 auto
    p
      font-size 14.5px
      color #333333
      line-height 20px
      margin 10px auto 0
      padding 0 26px
      text-align left
      position relative
    .need
      width 100%
    .btn-box
      margin 15px auto
      width 287px
      height 42px
      colCenter()
      .btn
        width 133px
        height 42px
        line-height 42px
        background #ededed
        color #666666
        font-size 17px
        border-radius 21px
      .now
        color #000000
</style>


// WEBPACK FOOTER //
// src/components/SettingInternet/SettingInternet.vue